import { render, staticRenderFns } from "./pageMode3.vue?vue&type=template&id=b9863df6"
import script from "./pageMode3.vue?vue&type=script&lang=js"
export * from "./pageMode3.vue?vue&type=script&lang=js"
import style0 from "./pageMode3.vue?vue&type=style&index=0&id=b9863df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports